import styles from '../index.module.css'

import React from 'react'

import type { ColorIndicator } from '@disco/utils/color-indicators'

import type { NativeTag } from 'types/track'

import { indicatorColorClass } from '../utils/indicator-colors'

/** A native tag narrowed to one carrying a palette color. */
export type ColoredTag = NativeTag & { color: ColorIndicator }

/** Passive color swatch shared by the dot tooltips and the overflow tag list. */
export const TagDot = ({ color }: { color: ColorIndicator }) => (
  <span className={`${styles.tagDot} ${indicatorColorClass(color)}`} />
)
